import React from "react";

// Auto-dismissing success/error banner shared by settings cards (password
// change, login methods, event promotion, ...).
function SettingsBanner({ message, error }) {
  return (
    <>
      {message && (
        <div className="mb-4 p-3 rounded-md text-sm bg-green-500/10 text-green-700 border border-green-500/20">
          {message}
        </div>
      )}
      {error && (
        <div className="mb-4 p-3 rounded-md text-sm bg-red-500/10 text-red-700 border border-red-500/20">
          {error}
        </div>
      )}
    </>
  );
}

export { SettingsBanner };
